












import {ChartDataTemplate, FCConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {computed, defineComponent, reactive} from "@vue/composition-api"
import {getLocationCaption} from "@/data/sources/appraisal"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {buildQueryDownloadUrl, executeQuery} from "@/data/repos/query";

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.KeyValue(),
    widget: "AsBuiltDrawingsByDate",
    title: "As Built Drawings By Date",
    params: {
      locationId: {...WParamTpl.regionId(), _order: 1},
    },
  }
}

function getChartConfig() {
  return reactive(FCConfTpl())
}

function getChartDataConfig() {
  return reactive({
        ...ChartDataTemplate(),
        caption: "As-Built CAD drawings by date",
        theme: "micad",
        // legendCaptionFontSize: "9",
        xAxisName: "Year",
        yAxisName: "Drawings",

        showValues: "1",
        showLabels: "1",
        rotateLabels: "1",
        showLegend: "1",
      },
  )
}

export default defineComponent({
  props: {
    config: Object,
  },
  components: {
    FusionChartWidget,
  },
  setup(props, context) {
    const downloadUrl = computed(() => {
      const params = props.config && props.config.params
      const locationId = parseInt(params.locationId.value)
      return buildQueryDownloadUrl("idr", "asBuiltDrawingsByDateDrillDown",{
        locationId
      })
    })

    let lastConfig: any
    let lastChartDataConfig: any
    async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
      if (config) {
        lastConfig = config
        lastChartDataConfig = chartDataConfig
        chartDataConfig.subCaption = "Location: " + await getLocationCaption(config.params.locationId)
      }
    }

    async function dataFetcher(params: any): Promise<{ data: any[] }> {
      const currentYear = new Date().getFullYear()
      const data: { year: number, dwgCount: number }[] = await executeQuery(
          "idr", "asBuiltDrawingsByDate", {
            locationId: parseInt(params.locationId.value) || 10
          });
      const totalDrawingCount = data.reduce(((previousValue, currentValue) => previousValue + currentValue.dwgCount), 0)
      lastChartDataConfig.caption = totalDrawingCount + ": " + lastConfig.title

      const minYear = data.reduce(((previousValue, currentValue) => Math.min(previousValue, currentValue.year)), currentYear)
      const maxYear = data.reduce(((previousValue, currentValue) => Math.max(previousValue, currentValue.year)), currentYear)
      const years: number[] = [...Array(maxYear - minYear + 1).keys()].map(i => i + minYear)
      const map: Map<number, number> = new Map()
      data.forEach((item => map.set(item.year, item.dwgCount)))

      return {
        data: years.map(year => {
          const dwgCount = map.get(year)
          return {
            label: String(year),
            value: dwgCount,
            color:
                year > currentYear - 4 ? "#6BAA01" :
                    year > currentYear - 8 ? "#FFBF00" :
                        "#DC143C",
            toolText: year + " - " + dwgCount,
          }
        })
      }
    }

    function chartClickCallback(label: string, val: any) {
      // const url = appConf.IPR_BASE_URL + '/reports/LocIssuesFloorsWithoutPlans.asp' // todo
      // window.open(url)
      console.info("TODO:", label, val)
    }

    context.emit('config-update', config())
    return {dataFetcher, getChartDataConfig, chartClickCallback, configChangeCallback, downloadUrl}
  },
})
